import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  fetchCarePlanAuditSuccess,
  fetchCarePlanAuditFailure,
} from "./actions";
import { FETCH_CARE_PLAN_AUDIT } from "./constants";
import { buildCarePlanAuditQuery } from "./schema";

/**
 * Fetch care plan audit for a location.
 * payload: { locationId, filters, append? }
 */
export function* fetchCarePlanAuditSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, filters, append = false } = payload || {};

  try {
    const query = buildCarePlanAuditQuery(filters);
    const response = yield call(
      api(token).get,
      `/api/location/${locationId}/care-plan-audit${query}`,
    );

    yield put(
      fetchCarePlanAuditSuccess({
        response: response || null,
        append: Boolean(append),
      }),
    );
    typeof onSuccess === "function" && onSuccess(response);
  } catch (e) {
    yield put(fetchCarePlanAuditFailure({ append: Boolean(append) }));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while fetching the care plan audit!"));
  }
}

export default function* CarePlanAuditSaga() {
  yield all([takeLatest(FETCH_CARE_PLAN_AUDIT, fetchCarePlanAuditSaga)]);
}
